import React from 'react';
import { Button } from 'reactstrap';
import SaleSupportForm from './SaleSupportForm';
import SaleSupportDelete from './SaleSupportDelete';


export default class SaleSupportIndex extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            deletingItem : null,
            editingItem : null,
        }

        this.startEdit = (item) => this.setState({editingItem : item, showForm : true});
        this.showForm = (item) => this.setState({editingItem : null, showForm : true});
        this.hideForm = () => this.setState({showForm : false});

        this.startDelete = (item) => this.setState({deletingItem : item});
        this.cancelDelete = () => this.setState({deletingItem : null});
    }

    componentWillMount(){
        this.props.fetchSupportItems();
    }

    componentWillReceiveProps(props) {
        if(this.props.support.deleting && ! props.support.deleting) {
            this.cancelDelete();
        }
        if(this.props.support.posting && ! props.support.posting) {
            // Give time to animation to end
            this.hideForm();
        }
    }

    render() {
        const state = this.props.support;
        const data = state.data || {};
        return (
            <div className="container">
                <div className="text-right">
                    <Button color="primary" onClick={this.showForm}>
                        <i className="fa fa-plus"></i> Añadir material
                    </Button>
                </div>
                {
                    state.fetching ?
                    <div>
                        <i className="fa fa-spinner fa-spin"></i> Cargando información
                    </div>
                    :
                        Object.keys(data).map((key) => (
                        <RenderCategory key={key} title={key} items={data[key]} editItem={this.startEdit} deleteItem={this.startDelete}/>
                    ))
                }
                <SaleSupportDelete
                isOpen={this.state.deletingItem !== null}
                hide={this.cancelDelete}
                item={this.state.deletingItem}
                deleteItem={this.props.deleteSupportItem}
                deleting={state.deleting}/>
                
                <SaleSupportForm
                isOpen={this.state.showForm}
                hide={this.hideForm}
                item={this.state.editingItem}
                store={this.props.storeSupportItem}
                posting={this.props.support.posting}
                progress={this.props.support.progress} />
            </div>
        );
    }
}

function RenderCategory(props) {
    if(! props.items || props.items.length === 0) return null;
    return (
        <div className="row">
            <div className="col-12">
                <h2 key={props.title}>
                    {props.title.toUpperCase()}
                </h2>
            </div>
            {
                props.items.map((item, i) => ([
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <div className="card">
                            <img className="card-img-top" src={item.cover_url} alt={item.title}/>
                            <div className="card-block">
                                <h5 className="card-title no-overflow mb-0">
                                    {item.title}
                                </h5>
                            </div>
                            <div className="card-footer text-right">
                                <button className="btn btn-secondary btn-sm mr-1" onClick={() => props.editItem(item)}>
                                    Editar
                                </button>
                                <button className="btn btn-danger btn-sm" onClick={() => props.deleteItem(item)}>
                                    <i className="fa fa-times"></i> Eliminar
                                </button>
                            </div>
                        </div>
                    </div>,
                    (i+1) % 4 === 0 ? <div className="clearfix hidden-md-down"></div> : null,
                    (i+1) % 3 === 0 ? <div className="clearfix hidden-sm-down hidden-lg-up"></div> : null,
                    (i+1) % 2 === 0 ? <div className="clearfix hidden-md-up"></div> : null
                    
                ]))
            }
        </div>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/support/SaleSupportIndex.jsx
 **/